import React, { useContext, useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import "./style.css";
import Swal from "sweetalert2";
import config from "../../config";
import $ from "jquery";
import printIcon from "../../images/icons/print.png";
import { printPrinter } from "../../utils";
import Tippy from "@tippyjs/react";
import { ConfigContext } from "../../App";

const ApiSuccessModal = (props) => {
  console.log("resDataresData", props?.resData);
  const navigate = useNavigate();
  const [isPdfShow, setIsPdfShow] = useState(null);
  const resetForm = () => {
    navigate(props.navigateToList);
    props.handleSccessClose();
  };
  const createNew = () => {
    navigate(props.navigateCreateNew);
    props.handleSccessClose();
  };

  function generatePdf() {
    // using Java Script method to get PDF file
    // setIsSubmit(true);
    setIsPdfShow(props.pdfId);
    $.post(
      `${config.apiUrl}/download`,
      JSON.stringify({
        type: props.pdfType,
        size: props.pdfSize,
        hdr_id: props.pdfId,
      }),
    )
      .done((res) => {
        if (res.status == 200) {
          let alink = document.createElement("a");
          alink.href = res.link;
          alink.download = `${props.pdfType}_${props.pdfId}.pdf`;
          alink.click();
        } else {
          Swal.fire({
            icon: "error",
            title: "Download PDF Error",
            text: res.message,
            confirmButtonText: "OK",
            allowEnterKey: false,
            allowEscapeKey: false,
            allowOutsideClick: false,
            focusConfirm: true,
          });
        }
      })
      .fail((err) => {
        Swal.fire({
          icon: "error",
          title: "Download PDF Error",
          text: err.responseJSON.message,
          confirmButtonText: "OK",
          allowEnterKey: false,
          allowEscapeKey: false,
          allowOutsideClick: false,
          focusConfirm: true,
        });
      })
      .always(function () {
        setIsPdfShow(null);
      });
  }
  const [showPageLoader, setShowPageLoader] = useState(false);
  const noPricePrint = useContext(ConfigContext).noPricePrint;
  const loginBranch = useContext(ConfigContext)?.loginBranch;
  const [user, setUser] = useState({});

  useEffect(function () {
    if (localStorage.getItem("inventory")) {
      setUser(JSON.parse(localStorage.getItem("inventory")).userData);
    }
  }, []);

  const printOptions = config.challanPrintOptions.filter((opt) => {
    if (noPricePrint != 1 && opt.key.includes("no_price")) return false;
    return true;
  });
  return (
    <div>
      <Modal show={props.showSccess} onHide={props.handleSccessClose} centered>
        <Modal.Body>
          <div className="row">
            <div className="col-12 mb-3 h-50">
              <>
                <h2 className="title">{props.headerMsg}</h2>
                <div className="dataContainer">
                  <p>Challan No:{props.challanId}</p>
                  {user?.role_id != 8 ? (
                    <img
                      src={props.qrImg}
                      alt=""
                      width="200px"
                      height="200px"
                    />
                  ) : (
                    ""
                  )}
                </div>
                {/* <div className="dataContainer">
                    <label className="text">
                      {props.createNewButtonText} Voucher No:
                      <b>{props.voucherNo}</b>
                    </label>
                    <br />
                    <label className="text">
                      {props?.uraText}
                      <b>{props?.uraRefNo}</b>
                    </label>
                  </div> */}
              </>
            </div>
            <div style={{ textAlign: "center", marginBottom: "10px" }}>
              <div
                className={`ms-3 ${user?.role_id == 8 || props?.is_active == 5 ? "d-none" : ""
                  }`}
              >
                <div className="dropdown d-inline-block">
                  <div className="btn-group">
                    <button
                      type="button"
                      className="btn border-0 p-0"
                      onClick={() => {
                        const defaultType =
                          loginBranch?.default_print_type ||
                          "_price_with_comp_name";
                        const opt = printOptions.find(
                          (o) => o.key === defaultType,
                        );
                        printPrinter(
                          props.printId,
                          defaultType,
                          setShowPageLoader,
                          opt?.compName ? user?.comp_data?.[0]?.comp_name : "",
                        );
                      }}
                    >
                      <img src={printIcon} className="img-fluid" alt="" style={{ width: "18px", height: "20px" }} />
                    </button>
                    <button
                      type="button"
                      className="btn dropdown-toggle dropdown-toggle-split border-0 p-0 ms-1"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      style={{ color: "black" }}
                    >
                      <span className="visually-hidden">Toggle Dropdown</span>
                    </button>
                    <ul className="dropdown-menu">
                      {printOptions.map((opt, index) => (
                        <li key={index}>
                          <button
                            className="dropdown-item border border-1"
                            onClick={() =>
                              printPrinter(
                                props.printId,
                                opt.key,
                                setShowPageLoader,
                                opt.compName
                                  ? user?.comp_data?.[0]?.comp_name || ""
                                  : "",
                              )
                            }
                          >
                            {opt.label}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 text-center">
              {props?.displayEditBtn ? (
                <button
                  style={{
                    border: 0,
                    borderRadius: "0.25em",
                    background: "initial",
                    backgroundColor: "#7066e0",
                    color: "#fff",
                    fontSize: "1em",
                    marginRight: "10px",
                    padding: "10px",
                    fontWeight: "600",
                    width: "80px",
                  }}
                  onClick={resetForm}
                >
                  Ok
                </button>
              ) : (
                <>
                  <button
                    style={{
                      border: 0,
                      borderRadius: "0.25em",
                      background: "initial",
                      backgroundColor: "#7066e0",
                      color: "#fff",
                      fontSize: "1em",
                      marginRight: "10px",
                      padding: "10px",
                      fontWeight: "600",
                    }}
                    onClick={createNew}
                  >
                    Create New {props.createNewButtonText}
                  </button>
                  <button
                    style={{
                      border: 0,
                      borderRadius: "0.25em",
                      background: "initial",
                      backgroundColor: "#6e7881",
                      color: "#fff",
                      fontSize: "1em",
                      padding: "10px",
                      fontWeight: "600",
                    }}
                    onClick={resetForm}
                  >
                    Back to List
                  </button>
                </>
              )}
            </div>
          </div>
        </Modal.Body>

        <div
          id="page-loader"
          style={{
            display: showPageLoader !== false ? "block" : "none",
            width: "100%",
            height: "100%",
            position: "fixed",
            top: 0,
            left: 0,
            background: "black",
            opacity: ".5",
            zIndex: "1000",
            textAlign: "center",
            color: "white",
            fontSize: "16px",
            fontWeight: "bold",
            paddingTop: "200px",
          }}
        >
          {showPageLoader}
        </div>
      </Modal>
    </div>
  );
};

export default ApiSuccessModal;
